class DataSection {
  constructor(sectionSelector, options = {}) {
    this.section = document.querySelector(sectionSelector);
    if (!this.section) return;

    this.trigger = this.section.querySelector('.data-section__trigger');
    this.container = this.section.querySelector('.data-section__content');
    this.items = this.section.querySelectorAll('.data-section__content-item');

    this.itemHeight = options.itemHeight || 94;
    this.fixedScrollStart = null;
    this.hasInit = false;
    this.lastScrollY = window.scrollY;

    this.bindEvents();
    this.initIfLargeScreen();
  }

  isLargeScreen() {
    return window.matchMedia("(min-width: 1200px)").matches;
  }

  /*reset() {
    if (this.trigger) {
      this.trigger.classList.remove('fixed', 'fixed-out');
      this.trigger.style.height = '';
    }
    this.items.forEach(item => {
      item.classList.remove('collapsed');
      item.style.height = '';
    });
    this.fixedScrollStart = null;
  }*/

  handleScrollCollapse() {
    if (!this.section.classList.contains('started')) return;
    if (!this.isLargeScreen() || !this.trigger || !this.container || this.items.length === 0) return;

    const triggerTop = this.trigger.getBoundingClientRect().top;
    const currentScrollY = window.scrollY;

    if (triggerTop > 100) {
      //this.reset();
      this.lastScrollY = currentScrollY;
      return;
    }

    if (!this.trigger.classList.contains('fixed') && !this.trigger.classList.contains('fixed-out')) {
      if (triggerTop <= 100) {
        this.fixedScrollStart = window.scrollY;
        this.trigger.classList.add('fixed');
        this.items.forEach(item => {
          item.style.height = item.scrollHeight + 'px';
        });
      } else {
        return;
      }
    }

    if (this.trigger.classList.contains('fixed')) {
      const scrolledInside = window.scrollY - this.fixedScrollStart;
      const itemsToCollapse = Math.floor(scrolledInside / this.itemHeight);

      this.items.forEach((item, index) => {
        item.style.height = item.scrollHeight + 'px';
        if (index + 1 <= itemsToCollapse) {
          item.classList.add('collapsed');
          item.style.height = this.itemHeight + 'px';
        } else {
          item.classList.remove('collapsed');
          item.style.height = item.scrollHeight + 'px';
        }
      });

      const viewportHeight = window.innerHeight;
      const containerHeight = this.container.offsetHeight;
      this.trigger.style.height = viewportHeight + (itemsToCollapse * 94) + 100 + 'px';

      /* console.log(this.items);
      const allCollapsed = [...this.items].every(item => item.classList.contains('collapsed'));
      console.log(allCollapsed);
      if (allCollapsed && scrolledInside >= (this.items.length * this.itemHeight * 2)) {
        this.items.forEach(item => {
          item.classList.remove('collapsed');
          item.style.height = 'auto';
        });
        this.trigger.style.transition = "height .3s cubic-bezier(0.22, 0.75, 0.4, 0.96)";
        this.trigger.style.height = '2px';
        this.container.scrollIntoView({behavior: 'smooth', block: 'start' });
        this.trigger.classList.remove('fixed');
        this.trigger.classList.add('fixed-out');
        this.fixedScrollStart = null;
      } */

      const allCollapsed = [...this.items].every(item => item.classList.contains('collapsed'));
      if (allCollapsed && scrolledInside >= (this.items.length * this.itemHeight)) {
        this.trigger.style.transition = "height .3s cubic-bezier(0.22, 0.75, 0.4, 0.96)";
        this.trigger.style.height = '10px';

        // esperar al final de la transición antes de cambiar el flow
        setTimeout(() => {
          this.trigger.classList.remove('fixed');
          this.trigger.classList.add('fixed-out');
          this.fixedScrollStart = null;
        }, 100);
      }
    }

    this.lastScrollY = currentScrollY;
  }

  initHoverBehavior() {
    this.items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        if (this.isLargeScreen() && item.classList.contains('collapsed')) {
          item.style.height = item.scrollHeight + 'px';
        }
      });
      item.addEventListener('mouseleave', () => {
        if (this.isLargeScreen() && item.classList.contains('collapsed')) {
          item.style.height = this.itemHeight + 'px';
        }
      });
    });
  }

  initIfLargeScreen() {
    if (!this.isLargeScreen()) return;
    //this.reset();
    this.initHoverBehavior();
    window.addEventListener('scroll', this.handleScrollCollapseBound);
    this.hasInit = true;
  }

  bindEvents() {
    this.handleScrollCollapseBound = this.handleScrollCollapse.bind(this);
    window.addEventListener('resize', () => {
      if (this.isLargeScreen()) {
        if (!this.hasInit) {
          this.initIfLargeScreen();
        }
      } else {
        //this.reset();
        this.hasInit = false;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const scrollPosition = window.scrollY;
  const target = document.querySelector('.js-data-section');
  if (!target) return;

  const dataSectionInstance = new DataSection('.js-data-section');

  const trigger = target.querySelector('.data-section__trigger');
  if (trigger) {
    const triggerPosition = trigger.getBoundingClientRect().top;
    if (triggerPosition > scrollPosition) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            target.classList.add('started');
          }
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -100px 0px"
      });
      observer.observe(trigger);
    }
  }

  target.classList.remove('started');
});
